import React, {useEffect, useState} from 'react';
import Toast from "cogo-toast";
import {apiGetEvents} from "./Actions";
import Widget from "../../components/widget";
import {Form} from "react-final-form";
import {Button} from "../../components/My/Button";
import SelectField from "../../FinalForm/SelectField";

const FilterEvents = ({subjectId, loading, onSubmit}) => {
    let [events, setEvents] = useState([]);

    useEffect(() => {
        getEvents()
    }, [subjectId]);

    const getEvents = () => {
        if (subjectId) {
            apiGetEvents(subjectId, (data) => {
                setEvents(data)
            }, (error) => {
                Toast.error("Nepodařilo se načíst události subjektu.")
                setEvents([])
            })
        } else {
            setEvents([])
        }
    }

    const getOptions = () => {
        let options = [];
        if (!events) return options;
        events.forEach(event => {
            options.push({label: <span>{event.name} <sup>{event.startTime}</sup></span>, value: event.id})
        })

        return options;

    }

    if (!subjectId) return null;

    return <Widget>
        <div className={"flex flex-col"}>
            <Form onSubmit={onSubmit}
                  render={({handleSubmit, form, values}) => (
                      <>
                          <div className={"flex flex-wrap w-full"}>
                              <div className={"w-1/2"}>
                                  <SelectField name={"eventId"} label={"Vyberte událost"}
                                               disabled={loading} onChange={(e) => {
                                      form.change("eventId", e?.value)
                                      form.change("isExcel", false)
                                      handleSubmit(values)
                                  }}
                                               options={getOptions()}
                                               isMandatory={false}
                                               isMulti={false}
                                  />
                              </div>
                              {/*<div className={"pt-6 ml-4"}>
                              <Button onClick={() => {
                                  form.change("isExcel", true)
                                  handleSubmit()
                              }} text={"Export"} loading={loading}/>
                          </div>*/}
                          </div>
                      </>
                  )}/>
        </div>
    </Widget>


}
export default FilterEvents;
